import { alpha, Stack, useTheme } from "@mui/material";
import { MoreHorizontal } from "lucide-react";
import type { FC } from "react";

export const DashboardMoreGoalsRing: FC = () => {
	const { palette, dashboard, iconSize, radii } = useTheme();
	const { ringSize } = dashboard.goalsCard;

	return (
		<Stack
			width={ringSize}
			height={ringSize}
			alignItems="center"
			justifyContent="center"
			borderRadius={radii.full}
			border={`2px dashed ${alpha(palette.darkmodeText.white, 0.5)}`}
		>
			<MoreHorizontal
				size={iconSize.md}
				color={palette.darkmodeText.white}
				aria-hidden
			/>
		</Stack>
	);
};
